import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import EcoLink from 'eco-design-components/base/eco-link';
import { useEffect, useState } from 'react';
import Modal from '../Modal';
import { icon1, icon2, icon3, icon4, iconBtn } from './icons/Icons';
import styles from './index.module.scss';

interface ItemType {
    svg: React.ReactElement<React.SVGProps<SVGSVGElement>>;
    title: string;
    desc: string;
}

const MultiSource = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const [open, setOpen] = useState(false);
    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });
    const [enterBtn, setEnterBtn] = useState(false);
    const [isPad, setIsPad] = useState(-1);

    const items: ItemType[] = [
        {
            svg: icon1,
            title: t('multi_source_section_title1'),
            desc: t('multi_source_section_desc1'),
        },
        {
            svg: icon2,
            title: t('multi_source_section_title2'),
            desc: t('multi_source_section_desc2'),
        },
        {
            svg: icon3,
            title: t('multi_source_section_title3'),
            desc: t('multi_source_section_desc3'),
        },
        {
            svg: icon4,
            title: t('multi_source_section_title4'),
            desc: t('multi_source_section_desc4'),
        },
    ];

    const modalList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267677880/modalList3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751267745271/modalList3-h5.jpg',
            title: t('multi_source_modal_title3'),
            desc: t.rich('multi_source_modal_desc3', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267678718/modalList1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751267677469/modalList1-h5.jpg',
            title: t('multi_source_modal_title1'),
            desc: t.rich('multi_source_modal_desc1', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751267678277/modalList2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751267678511/modalList2-h5.jpg',
            title: t('multi_source_modal_title2'),
            desc: t.rich('multi_source_modal_desc2', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1759999474175/modalList4-pc.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1759999492976/modalList4-h5.jpg',
            title: t('multi_source_modal_title4'),
            desc: t.rich('multi_source_modal_desc4', {
                em: (text: string) => <span className="em">{text}</span>,
            }),
            learnMore: 'http://www.ecoflow.com/us/ocean-smart-electrical-panel-40',
        },
    ];

    const handleClick = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_details',
            tab: t(`multi_source_title`),
            button_name: t(`multi_source_btn`),
            __btn_id1: styles.multiSource,
            __btn_id2: t(`multi_source_btn`),
        });
        setOpen((v) => !v);
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && isPad !== 1) {
            const isPadValue = window.innerWidth < 1024 ? 1 : 0;
            setIsPad(isPadValue);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const aniArr = ['label', 'title', 'desc'];
            const scenes: any = {};
            // 1. 文字动效
            aniArr.forEach((item) => {
                const domInfo: HTMLDialogElement | null = document.querySelector(`.${styles.multiSource} .info .${item}`);
                if (domInfo) {
                    scenes[item] = AniContainer.create({
                        triggerElement: domInfo,
                        triggerHook: 1,
                        offset: domInfo.offsetHeight,
                        duration: '150%',
                        onEnter: () => setEnter((prev) => ({ ...prev, [item]: true })),
                        onLeave: () => setEnter((prev) => ({ ...prev, [item]: false })),
                    });
                }
            });

            const domBtn: HTMLDivElement | null = document.querySelector(`.${styles.multiSource} .btn-box`);
            if (domBtn) {
                const sceneBtn = AniContainer.create({
                    triggerElement: domBtn,
                    triggerHook: 1,
                    offset: 60,
                    duration: '200%',
                    onEnter: () => setEnterBtn(true),
                    onLeave: () => setEnterBtn(false),
                });
                return () => {
                    Object.values(scenes).forEach((item: any) => item.destroy());
                    sceneBtn.destroy();
                };
            }
        }
    }, []);

    return (
        <div className={`${styles.multiSource} GtmModuleData-section`} data-section-id={styles.multiSource} data-section-title={t(`multi_source_title`)}>
            <div className="bg-img">
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/upload/image/1759999164835/MultiSource-pc.jpg'}
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1759999164651/MultiSource-h5.jpg"
                    alt={t('multi_source_title')}
                />
            </div>
            <div className="box">
                <div className="info">
                    <p className={`label${enter.label ? ' enter' : ''}`}>{t('multi_source_label')}</p>
                    <h2 className={`title${enter.title ? ' enter' : ''}`}>{t('multi_source_title')}</h2>
                    <p className={`desc${enter.desc ? ' enter' : ''}`}>{t('multi_source_intro')}</p>
                </div>
                <ul className="items">
                    {items?.map((item: ItemType, k: number) => (
                        <li className="item" key={k}>
                            {item.svg}
                            <div className="item-text">
                                <span className="item-title">{item.title}</span>
                                <span className="item-desc">{item.desc}</span>
                            </div>
                        </li>
                    ))}
                </ul>
                <div className="btn-box">
                    <div className={`GtmModuleData-btn-text btn-ani${open ? ' active' : ''}${enterBtn ? ' enter' : ''}`} onClick={handleClick}>
                        <span>{t(`multi_source_btn`)}</span>
                        {iconBtn}
                    </div>
                </div>
            </div>

            <Modal open={open} onClose={() => setOpen(false)} theme="black">
                <div
                    className={`${styles.multiModal} GtmModuleData-section`}
                    data-section-id={styles.multiModal}
                    data-section-title={t(`multi_source_modal_title`)}
                >
                    <h2>{t(`multi_source_modal_title`)}</h2>
                    {modalList.map((item) => (
                        <div key={item.title} className="item">
                            <div className="text-wrapper">
                                <h3>{item.title}</h3>
                                <p>{item.desc}</p>
                                {item.learnMore && (
                                    <EcoLink
                                        href={item.learnMore}
                                        target="_blank"
                                        className="learn-more GtmModuleData-btn-href"
                                        dataLayer={{
                                            __btn_id1: styles.multiModal,
                                            __btn_id2: item.learnMore,
                                        }}
                                    >
                                        {t(`multi_source_learn_more`)}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                            <path
                                                d="M7.5 5.5L12.5 10.5L7.5 15.5"
                                                stroke="white"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    </EcoLink>
                                )}
                            </div>
                            <EFPicture src={item.pc} srcMobile={item.h5} alt={item.title} className="img" />
                        </div>
                    ))}
                </div>
            </Modal>
        </div>
    );
};

export default MultiSource;
